module.exports = __webpack_public_path__ + "img/clientes_4.49026d22.png";